import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// Suprime el overlay de errores de runtime de CRA para AxiosError 401:
// son rechazos esperados del flujo de auth (p.ej. /auth/me sin sesión activa)
// y ya se gestionan en AuthContext/interceptor. Sin esto, StrictMode + dev
// muestra el overlay rojo aunque el .catch los maneje.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const err = event?.reason;
    if (err && err.isAxiosError && err.response && err.response.status === 401) {
      event.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
